import barba from "@barba/core";
import Sticky from "sticky-js";
import imagesLoaded from "imagesloaded";

const initSticky = () => {
    let sticky = null;
    imagesLoaded('.page-wrapper', () => {
        sticky = new Sticky(
            ".sticky",
            {
                marginTop: 200,
                stickyFor: 1023,
            },
            500
        );
	});
    Array.from(document.images).forEach((image) => {
        image.addEventListener("load", () => {
            if(sticky){
                sticky.update();
            }
        });
    });
};

barba.hooks.afterEnter(initSticky);
window.addEventListener("load", initSticky);
